"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ChiRhos API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class PersonApi extends runtime.BaseAPI {
    /**
     */
    apiPersonActivatePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Activate`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRawRequestToJSON(requestParameters.apiEntityRawRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonActivatePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonActivatePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonDeactivatePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Deactivate`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRawRequestToJSON(requestParameters.apiEntityRawRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonDeactivatePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonDeactivatePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Person`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPersonDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPersonDeleteRaw(requestParameters);
        });
    }
    /**
     */
    apiPersonFavouriteAddPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Favourite/Add`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRawRequestToJSON(requestParameters.apiEntityRawRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPersonFavouriteAddPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPersonFavouriteAddPostRaw(requestParameters);
        });
    }
    /**
     * Currently supports retrieval of up to 50 person records at once
     */
    apiPersonGetMultiplePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/GetMultiple`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityMultipleRequestToJSON(requestParameters.apiEntityMultipleRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorableIEnumerableDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Currently supports retrieval of up to 50 person records at once
     */
    apiPersonGetMultiplePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonGetMultiplePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonGetPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Get`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonGetPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonGetPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonGetSelfGetRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Person/GetSelf`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonGetSelfGet() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonGetSelfGetRaw();
            return yield response.value();
        });
    }
    /**
     */
    apiPersonHistoryPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/History`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiHistoryRequestToJSON(requestParameters.apiHistoryRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ActivityIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonHistoryPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonHistoryPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     */
    apiPersonImportPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.importIdentifier !== undefined) {
                queryParameters['importIdentifier'] = requestParameters.importIdentifier;
            }
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.file !== undefined) {
                formParams.append('file', requestParameters.file);
            }
            const response = yield this.request({
                path: `/api/Person/Import`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IImportIStorableFromJSON(jsonValue));
        });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     */
    apiPersonImportPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonImportPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonInviteAcceptGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.secret !== undefined) {
                queryParameters['secret'] = requestParameters.secret;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Person/Invite/Accept`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonInviteAcceptGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonInviteAcceptGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Sends the unique code for a person to their stored contact details
     */
    apiPersonInviteAllMatchingPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Invite/AllMatching`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiForgottenRequestToJSON(requestParameters.apiForgottenRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.Int32IDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Sends the unique code for a person to their stored contact details
     */
    apiPersonInviteAllMatchingPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonInviteAllMatchingPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * This sends an invite to the person with this email address.
     */
    apiPersonInviteEmailGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.email !== undefined) {
                queryParameters['email'] = requestParameters.email;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Person/Invite/Email`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * This sends an invite to the person with this email address.
     */
    apiPersonInviteEmailGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPersonInviteEmailGetRaw(requestParameters);
        });
    }
    /**
     * This sends an invite to this person to take ownership of this person record.
     */
    apiPersonInvitePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Invite`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRawRequestToJSON(requestParameters.apiEntityRawRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * This sends an invite to this person to take ownership of this person record.
     */
    apiPersonInvitePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPersonInvitePostRaw(requestParameters);
        });
    }
    /**
     */
    apiPersonListForGroupPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/ListForGroup`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityFilteredPagedRequestToJSON(requestParameters.apiEntityFilteredPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorablePagedResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonListForGroupPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonListForGroupPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonListForGroupSecurablePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/ListForGroupSecurable`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityFilteredPagedRequestToJSON(requestParameters.apiEntityFilteredPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonSecurablePagedResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonListForGroupSecurablePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonListForGroupSecurablePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonListForGroupTypePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/ListForGroupType`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityFilteredPagedRequestToJSON(requestParameters.apiEntityFilteredPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorablePagedResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonListForGroupTypePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonListForGroupTypePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Pass no entityId / empty GUID to get all inactive for all groups in the tenant
     */
    apiPersonListInactivePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/ListInactive`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityOptionalPagedRequestToJSON(requestParameters.apiEntityOptionalPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorablePagedResponseFromJSON(jsonValue));
        });
    }
    /**
     * Pass no entityId / empty GUID to get all inactive for all groups in the tenant
     */
    apiPersonListInactivePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonListInactivePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Note that the Order and Sort are ignored for this call as it is ordered by ranking
     */
    apiPersonLookupPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Lookup`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiSearchPagedRequestToJSON(requestParameters.apiSearchPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonPagedResponseFromJSON(jsonValue));
        });
    }
    /**
     * Note that the Order and Sort are ignored for this call as it is ordered by ranking
     */
    apiPersonLookupPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonLookupPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Note that the Order and Sort are ignored for this call as it is ordered by ranking
     */
    apiPersonLookupSecurablePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/LookupSecurable`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiSearchPagedRequestToJSON(requestParameters.apiSearchPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonSecurablePagedResponseFromJSON(jsonValue));
        });
    }
    /**
     * Note that the Order and Sort are ignored for this call as it is ordered by ranking
     */
    apiPersonLookupSecurablePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonLookupSecurablePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonMembershipExportDeleteDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Person/Membership/Export/Delete`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPersonMembershipExportDeleteDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPersonMembershipExportDeleteDeleteRaw(requestParameters);
        });
    }
    /**
     * Lists all membership export definitions for the given group
     */
    apiPersonMembershipExportListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Membership/Export/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IMembershipExportIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Lists all membership export definitions for the given group
     */
    apiPersonMembershipExportListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonMembershipExportListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Note that the fields property is for client usage, and do not affect the fields returned.
     */
    apiPersonMembershipExportRunPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Membership/Export/Run`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.MembershipExportConstructToJSON(requestParameters.membershipExportConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Note that the fields property is for client usage, and do not affect the fields returned.
     */
    apiPersonMembershipExportRunPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonMembershipExportRunPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Saves a membership export definition for the given group. Note that the fields property is simply storage for client usage, and do not affect the fields returned.
     */
    apiPersonMembershipExportSavePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Membership/Export/Save`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.MembershipExportConstructToJSON(requestParameters.membershipExportConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IMembershipExportIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Saves a membership export definition for the given group. Note that the fields property is simply storage for client usage, and do not affect the fields returned.
     */
    apiPersonMembershipExportSavePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonMembershipExportSavePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonMembershipGroupAcceptPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Membership/Group/Accept`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiMembershipRequestToJSON(requestParameters.apiMembershipRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonMembershipGroupAcceptPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonMembershipGroupAcceptPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonMembershipGroupActivatePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Membership/Group/Activate`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiMembershipRequestToJSON(requestParameters.apiMembershipRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonMembershipGroupActivatePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonMembershipGroupActivatePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonMembershipGroupAddPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Membership/Group/Add`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiMembershipRequestToJSON(requestParameters.apiMembershipRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonMembershipGroupAddPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonMembershipGroupAddPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Summarises all membership approvals that are in groups the current person is a writable member of
     */
    apiPersonMembershipGroupAwaitingApprovalGetRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Person/Membership/Group/AwaitingApproval`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.GroupSummaryResponseIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Summarises all membership approvals that are in groups the current person is a writable member of
     */
    apiPersonMembershipGroupAwaitingApprovalGet() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonMembershipGroupAwaitingApprovalGetRaw();
            return yield response.value();
        });
    }
    /**
     */
    apiPersonMembershipGroupDeactivatePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Membership/Group/Deactivate`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiMembershipRequestToJSON(requestParameters.apiMembershipRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonMembershipGroupDeactivatePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonMembershipGroupDeactivatePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     */
    apiPersonMembershipGroupImportPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.importIdentifier !== undefined) {
                queryParameters['importIdentifier'] = requestParameters.importIdentifier;
            }
            if (requestParameters.createDependencies !== undefined) {
                queryParameters['createDependencies'] = requestParameters.createDependencies;
            }
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.file !== undefined) {
                formParams.append('file', requestParameters.file);
            }
            const response = yield this.request({
                path: `/api/Person/Membership/Group/Import`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IImportIStorableFromJSON(jsonValue));
        });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     */
    apiPersonMembershipGroupImportPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonMembershipGroupImportPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonMembershipGroupRemovePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Membership/Group/Remove`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiMembershipRequestToJSON(requestParameters.apiMembershipRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonMembershipGroupRemovePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonMembershipGroupRemovePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonMembershipGroupTypeAddPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Membership/GroupType/Add`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiMembershipRequestToJSON(requestParameters.apiMembershipRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonMembershipGroupTypeAddPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonMembershipGroupTypeAddPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonMembershipGroupTypeRemovePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Membership/GroupType/Remove`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiMembershipRequestToJSON(requestParameters.apiMembershipRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonMembershipGroupTypeRemovePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonMembershipGroupTypeRemovePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonMembershipReportDeleteDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Person/Membership/Report/Delete`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPersonMembershipReportDeleteDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPersonMembershipReportDeleteDeleteRaw(requestParameters);
        });
    }
    /**
     */
    apiPersonMembershipReportListForGroupTypePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Membership/Report/ListForGroupType`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IReportIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonMembershipReportListForGroupTypePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonMembershipReportListForGroupTypePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonMembershipReportListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Membership/Report/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IReportIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonMembershipReportListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonMembershipReportListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * The Filters collection will filter the Roles, the property filters will filter the Persons
     */
    apiPersonMembershipReportRunPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Membership/Report/Run`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ReportConstructToJSON(requestParameters.reportConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ReportResponseFromJSON(jsonValue));
        });
    }
    /**
     * The Filters collection will filter the Roles, the property filters will filter the Persons
     */
    apiPersonMembershipReportRunPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonMembershipReportRunPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonMembershipReportSaveForGroupTypePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Membership/Report/SaveForGroupType`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ReportConstructToJSON(requestParameters.reportConstruct),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPersonMembershipReportSaveForGroupTypePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPersonMembershipReportSaveForGroupTypePostRaw(requestParameters);
        });
    }
    /**
     */
    apiPersonMembershipReportSavePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Membership/Report/Save`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ReportConstructToJSON(requestParameters.reportConstruct),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPersonMembershipReportSavePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPersonMembershipReportSavePostRaw(requestParameters);
        });
    }
    /**
     */
    apiPersonNoteListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Note/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityWithDeletedRequestToJSON(requestParameters.apiEntityWithDeletedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.INoteIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonNoteListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonNoteListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonNotificationsInPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Notifications/In`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiPagedRequestToJSON(requestParameters.apiPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.INotificationIStorablePagedResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonNotificationsInPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonNotificationsInPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonNotificationsOutPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Notifications/Out`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiPagedRequestToJSON(requestParameters.apiPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.INotificationIStorablePagedResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonNotificationsOutPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonNotificationsOutPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonOwnerAddPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Owner/Add`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiAddOwnerRequestToJSON(requestParameters.apiAddOwnerRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonOwnerAddPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonOwnerAddPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports. Reset flag will clear any existing owners.
     */
    apiPersonOwnerImportPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.importIdentifier !== undefined) {
                queryParameters['importIdentifier'] = requestParameters.importIdentifier;
            }
            if (requestParameters.reset !== undefined) {
                queryParameters['reset'] = requestParameters.reset;
            }
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.file !== undefined) {
                formParams.append('file', requestParameters.file);
            }
            const response = yield this.request({
                path: `/api/Person/Owner/Import`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IImportIStorableFromJSON(jsonValue));
        });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports. Reset flag will clear any existing owners.
     */
    apiPersonOwnerImportPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonOwnerImportPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonOwnerListOwnedPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Owner/ListOwned`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiPagedFilteredRequestToJSON(requestParameters.apiPagedFilteredRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorablePagedResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonOwnerListOwnedPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonOwnerListOwnedPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * The entity ID passed in is the owner request entity ID
     */
    apiPersonOwnerRequestApprovePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Owner/Request/Approve`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRawRequestToJSON(requestParameters.apiEntityRawRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IOwnerRequestIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * The entity ID passed in is the owner request entity ID
     */
    apiPersonOwnerRequestApprovePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonOwnerRequestApprovePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonOwnerRequestApprovedPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Owner/Request/Approved`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiRequestToJSON(requestParameters.apiRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IOwnerRequestIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonOwnerRequestApprovedPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonOwnerRequestApprovedPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * The entity ID passed in is the owner request entity ID
     */
    apiPersonOwnerRequestDeclinePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Owner/Request/Decline`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRawRequestToJSON(requestParameters.apiEntityRawRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IOwnerRequestIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * The entity ID passed in is the owner request entity ID
     */
    apiPersonOwnerRequestDeclinePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonOwnerRequestDeclinePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonOwnerRequestDeclinedPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Owner/Request/Declined`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiRequestToJSON(requestParameters.apiRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IOwnerRequestIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonOwnerRequestDeclinedPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonOwnerRequestDeclinedPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonOwnerRequestExpiredPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Owner/Request/Expired`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiRequestToJSON(requestParameters.apiRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IOwnerRequestIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonOwnerRequestExpiredPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonOwnerRequestExpiredPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonOwnerRequestPendingPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Owner/Request/Pending`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiRequestToJSON(requestParameters.apiRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IOwnerRequestIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonOwnerRequestPendingPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonOwnerRequestPendingPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * The entity ID passed in is the person you wish to request ownership of
     */
    apiPersonOwnerRequestPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Owner/Request`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRawRequestToJSON(requestParameters.apiEntityRawRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IOwnerRequestIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * The entity ID passed in is the person you wish to request ownership of
     */
    apiPersonOwnerRequestPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonOwnerRequestPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.PersonConstructToJSON(requestParameters.personConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Lists all available protected properties that the current user can view and set. Note that isMandatory is ignored.
     */
    apiPersonProtectedPropertiesAvailablePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/ProtectedProperties/Available`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiRequestToJSON(requestParameters.apiRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ProtectedPropertyContainerIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Lists all available protected properties that the current user can view and set. Note that isMandatory is ignored.
     */
    apiPersonProtectedPropertiesAvailablePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonProtectedPropertiesAvailablePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Deletes a protected property definition for a group
     */
    apiPersonProtectedPropertiesGroupEntityIdDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.entityId === null || requestParameters.entityId === undefined) {
                throw new runtime.RequiredError('entityId', 'Required parameter requestParameters.entityId was null or undefined when calling apiPersonProtectedPropertiesGroupEntityIdDelete.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Person/ProtectedProperties/Group/{entityId}`.replace(`{${"entityId"}}`, encodeURIComponent(String(requestParameters.entityId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a protected property definition for a group
     */
    apiPersonProtectedPropertiesGroupEntityIdDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPersonProtectedPropertiesGroupEntityIdDeleteRaw(requestParameters);
        });
    }
    /**
     * Lists protected property definitions for a group. Note that isMandatory is ignored.
     */
    apiPersonProtectedPropertiesGroupListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/ProtectedProperties/Group/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IProtectedPropertyIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Lists protected property definitions for a group. Note that isMandatory is ignored.
     */
    apiPersonProtectedPropertiesGroupListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonProtectedPropertiesGroupListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Saves a protected property definition for a group. Note that isMandatory is ignored.
     */
    apiPersonProtectedPropertiesGroupSavePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/ProtectedProperties/Group/Save`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ProtectedPropertyConstructToJSON(requestParameters.protectedPropertyConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IProtectedPropertyIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Saves a protected property definition for a group. Note that isMandatory is ignored.
     */
    apiPersonProtectedPropertiesGroupSavePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonProtectedPropertiesGroupSavePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Saves protected properties for a person. Note that isMandatory is ignored.
     */
    apiPersonProtectedPropertiesSavePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/ProtectedProperties/Save`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiProtectedPropertiesRequestToJSON(requestParameters.apiProtectedPropertiesRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Saves protected properties for a person. Note that isMandatory is ignored.
     */
    apiPersonProtectedPropertiesSavePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPersonProtectedPropertiesSavePostRaw(requestParameters);
        });
    }
    /**
     * Recreates the unique code for a person which can be used to, for example, check in for an event
     */
    apiPersonRecreateUniqueCodePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/RecreateUniqueCode`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     * Recreates the unique code for a person which can be used to, for example, check in for an event
     */
    apiPersonRecreateUniqueCodePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonRecreateUniqueCodePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonResourceDeletePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Person/Resource/Delete`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPersonResourceDeletePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPersonResourceDeletePostRaw(requestParameters);
        });
    }
    /**
     */
    apiPersonResourceFilePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Resource/File`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.StreamFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonResourceFilePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonResourceFilePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonResourceListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Resource/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityFilteredPagedRequestToJSON(requestParameters.apiEntityFilteredPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IResourceIStorablePagedSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonResourceListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonResourceListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Gets a resource file for a person. This call does not support point in time. For point in time requests, use [POST]Resource/File
     */
    apiPersonResourceResourceEntityIdFileNameGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.resourceEntityId === null || requestParameters.resourceEntityId === undefined) {
                throw new runtime.RequiredError('resourceEntityId', 'Required parameter requestParameters.resourceEntityId was null or undefined when calling apiPersonResourceResourceEntityIdFileNameGet.');
            }
            if (requestParameters.fileName === null || requestParameters.fileName === undefined) {
                throw new runtime.RequiredError('fileName', 'Required parameter requestParameters.fileName was null or undefined when calling apiPersonResourceResourceEntityIdFileNameGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Person/Resource/{resourceEntityId}/{fileName}`.replace(`{${"resourceEntityId"}}`, encodeURIComponent(String(requestParameters.resourceEntityId))).replace(`{${"fileName"}}`, encodeURIComponent(String(requestParameters.fileName))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.StreamFromJSON(jsonValue));
        });
    }
    /**
     * Gets a resource file for a person. This call does not support point in time. For point in time requests, use [POST]Resource/File
     */
    apiPersonResourceResourceEntityIdFileNameGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonResourceResourceEntityIdFileNameGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Gets a resource file for a person. This call does not support point in time. For point in time requests, use [POST]Resource/File
     */
    apiPersonResourceResourceEntityIdGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.resourceEntityId === null || requestParameters.resourceEntityId === undefined) {
                throw new runtime.RequiredError('resourceEntityId', 'Required parameter requestParameters.resourceEntityId was null or undefined when calling apiPersonResourceResourceEntityIdGet.');
            }
            const queryParameters = {};
            if (requestParameters.fileName !== undefined) {
                queryParameters['fileName'] = requestParameters.fileName;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Person/Resource/{resourceEntityId}`.replace(`{${"resourceEntityId"}}`, encodeURIComponent(String(requestParameters.resourceEntityId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.StreamFromJSON(jsonValue));
        });
    }
    /**
     * Gets a resource file for a person. This call does not support point in time. For point in time requests, use [POST]Resource/File
     */
    apiPersonResourceResourceEntityIdGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonResourceResourceEntityIdGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct (note that the Limit.IsOpen is the only security that is checked for a Person\'s resources)
     */
    apiPersonResourceSavePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.resourceJson !== undefined) {
                queryParameters['resourceJson'] = requestParameters.resourceJson;
            }
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.file !== undefined) {
                formParams.append('file', requestParameters.file);
            }
            const response = yield this.request({
                path: `/api/Person/Resource/Save`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IResourceIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct (note that the Limit.IsOpen is the only security that is checked for a Person\'s resources)
     */
    apiPersonResourceSavePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonResourceSavePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiPersonRestorePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Person/Restore`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiPersonRestorePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPersonRestorePostRaw(requestParameters);
        });
    }
    /**
     */
    apiPersonSearchReIndexPostRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Person/SearchReIndex`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.Int32IDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiPersonSearchReIndexPost() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonSearchReIndexPostRaw();
            return yield response.value();
        });
    }
    /**
     * Sends the unique code for a person to their stored contact details
     */
    apiPersonSendUniqueCodePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/SendUniqueCode`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiForgottenRequestToJSON(requestParameters.apiForgottenRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.Int32IDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Sends the unique code for a person to their stored contact details
     */
    apiPersonSendUniqueCodePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiPersonSendUniqueCodePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Wipes a person\'s sensitive personal details. CANNOT BE REVERSED.
     */
    apiPersonWipePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Person/Wipe`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Wipes a person\'s sensitive personal details. CANNOT BE REVERSED.
     */
    apiPersonWipePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiPersonWipePostRaw(requestParameters);
        });
    }
}
exports.PersonApi = PersonApi;
